// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.kyb-message[data-v-4544116c] {\n  border-left: 0.8rem solid var(--brand);\n  background-color: var(--light-br-gray);\n  font-size: 1.2rem;\n  font-weight: 600;\n  padding: 1.25rem 1.5rem;\n  margin-bottom: 1.5rem;\n}\n", ""]);
// Exports
module.exports = exports;
